import React from 'react';

import { Box, Button, TextField } from '@mui/material';

import styled from '@emotion/styled';
import { Formik } from 'formik';
import * as yup from 'yup';

import BaseDialog, { BaseDialogProps } from '../Base';

const schema = yup.object({
  shopifyName: yup.string().required('Required'),
});

type Props = {
  title?: string;
  onSubmitHandle: (name: string) => void;
} & BaseDialogProps;

export const AddShopifyStoreDialog: React.FC<Props> = ({ onSubmitHandle, ...rest }) => {
  return (
    <BaseDialog
      width='590px'
      height={'390px'}
      titleComponent={<ModalTitle>+Add Store</ModalTitle>}
      {...rest}
    >
      <Box
        sx={{
          paddingX: '18px',
          paddingY: '12px',
        }}
      >
        <Heading>
          Connect your store to Beautypass to start selling your products and services.
        </Heading>
        <Formik
          validationSchema={schema}
          initialValues={{ shopifyName: '' }}
          onSubmit={(values) => {
            onSubmitHandle(values.shopifyName.toLowerCase().trim());
            if (rest?.onClose) rest?.onClose({}, 'backdropClick');
          }}
        >
          {({ values, handleSubmit, setValues }) => {
            return (
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  id='storeName'
                  name='storeName'
                  placeholder={'Store Name'}
                  className='offer-input-field'
                  sx={{ marginTop: '24px' }}
                  type='text'
                  value={values.shopifyName}
                  onChange={(e) => {
                    setValues({
                      ...values,
                      shopifyName: e.target.value,
                    });
                  }}
                />
                <Box mt={8}>
                  <Button
                    fullWidth
                    variant='contained'
                    sx={{ paddingY: '15px', marginTop: '10px' }}
                    type='submit'
                    disabled={!values.shopifyName}
                  >
                    Connect to shopify
                  </Button>
                </Box>
              </form>
            );
          }}
        </Formik>
      </Box>
    </BaseDialog>
  );
};

const Heading = styled.h1`
  margin: 0;
  padding: 0;

  color: #111;
  font-size: 24px;
  font-weight: 500;
`;

const ModalTitle = styled.span`
  color: #848484;
  font-size: 15px;
  font-weight: 500;
`;

export const DiscountedText = styled.span`
  color: #848484;
  font-size: 15px;
  font-weight: 400;
  display: inline-block;
`;
